<template>
    <div class="p_top_header relative cases">
        <div class="top_title">
            <div class="animation_text m_r_10">
                {{{ $t('sections.cases.title') }}}
            </div>
        </div>
        <div class="bg_cases" v-for="bg in records.cases" :style="{ backgroundImage: 'url(' + bg.background + ')' }" :class="{ 'active': activeEl == bg.bg_box }"></div>
        <div class="row relative">
            <div class="col-xs-12 col-sm-6 col-md-4" v-for="item in records.cases">
                <a :href="item.behance" target="_blank" class="box_cases" :class="{ 'active': activeEl == item.bg_box }" @mouseenter="mouseIn(item)" @mouseleave="mouseOut()">
                    <div class="img_case" :style="setImageOpacity(item)" :class="item.bg_box"></div>
                    <div class="content_cases">
                        <div class="d_table h_full">
                            <div class="d_table_cell">
                                <img :src="item.logo" :alt="item.alt">
                                <h4>{{ item.name }}</h4>
                                <span>{{ item.description[getLang] }}</span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import jQuery from 'jquery'
    import { getLang } from '../vuex/settings/getters'

    export default {
        name: 'Cases',
        data () {
            return {
                records: require('../data/cases.json'),
                activeEl: '',
                meta: {
                    title: 'Cases',
                    description: 'Veja com mais detalhes os cases de projetos desenvolvidos pela Guco',
                    pageUrl: 'http://www.guco.com.br/cases',
                }
            }
        },
        head: {
            title () {
                return {
                    inner: this.meta.title
                }
            },
            meta () {
                return {
                    // Basic meta
                    name: {
                        'description' : this.meta.description,
                        'twitter:title': this.meta.title + ' | ' + this.meta.appName,
                        'twitter:description': this.meta.description,
                    },
                    // Google+ / Schema.org
                    itemprop: {
                        name: this.meta.title + ' | ' + this.meta.appName,
                        description: this.meta.description,
                    },
                    // Facebook / Open Graph
                    property: {
                        'og:url': this.meta.pageUrl,
                        'og:title': this.meta.title + ' | ' + this.meta.appName,
                        'og:description': this.meta.description,
                    }
                }
            },
            link () {
                return {
                    canonical: {
                        href: this.meta.pageUrl
                    },
                }
            }
        },
        vuex: {
            getters: {
                getLang
            }
        },
        computed: {
            backgroundImage () {
                return {
                    backgroundImage: 'url(' + this.bgImage + ')'
                }
            },
        },
        methods: {
            mouseIn (record) {
                this.activeEl = record.bg_box;
            },
            mouseOut () {
                this.activeEl = '';
            },
            setImageOpacity (record) {
                if(this.activeEl == '')
                    return { opacity: 1 }

                return { opacity: this.activeEl == record.bg_box ? '1' : 0 }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// Cases.vue?98e4442e